import {endpointsApi} from './endpoints-api';

const urlApi = 'https://koutravo-api-pre.central-ws.com/';

export const environment = {
	production: false,
	name: 'dev',
	stripePublishableKey: 'pk_test_51PkSyM03zgTiR8HulDi1hnWeqPYrcoUZzl2WBoZk4LVKHLGLfA8IOtfD0ZcRhiLS1I2i2ttqRP5nlEH9MqOO49i800chGFdKJo',
	analytics_id_seloger: "G-0ZYPRN97V0",
	analytics_id_koutravo: "G-N60W4LC7HX",
	pixel_id_seloger: "676862028108144",
	pixel_id_koutravo: "",
	...endpointsApi(urlApi)
};
